var spacersDefault = 16;
export var spacers = {
  s0: spacersDefault * 0.125,
  // 2px
  s1: spacersDefault * 0.25,
  // 4px
  s2: spacersDefault * 0.5,
  // 8px
  s3: spacersDefault * 0.75,
  // 12px
  s4: spacersDefault * 1,
  // 16px
  s5: spacersDefault * 1.5,
  // 24px
  s6: spacersDefault * 2,
  // 32px
  s7: spacersDefault * 3,
  // 48px
  s8: spacersDefault * 4,
  // 64px
  s9: spacersDefault * 6,
  // 96px
  s10: spacersDefault * 8,
  // 128px
  s11: spacersDefault * 12,
  // 192px
  s12: spacersDefault * 16,
  // 256px
  s13: spacersDefault * 24,
  // 384px
  s14: spacersDefault * 32,
  // 512px
  s15: spacersDefault * 40,
  // 640px
  s16: spacersDefault * 48 // 768px

};
var devicesBreakpoints = {
  tabletMin: 768,
  desktopMin: 1024
};
export var devices = {
  mobile: "(max-width: ".concat(devicesBreakpoints.tabletMin - 1, "px)"),
  tablet: "(min-width: ".concat(devicesBreakpoints.tabletMin, "px) and (max-width: ").concat(devicesBreakpoints.desktopMin - 1, "px)"),
  desktop: "(min-width: ".concat(devicesBreakpoints.desktopMin, "px)"),
  'mobile+tablet': "(max-width: ".concat(devicesBreakpoints.desktopMin - 1, "px)"),
  'mobile+desktop': "(max-width: ".concat(devicesBreakpoints.tabletMin - 1, "px), (min-width: ").concat(devicesBreakpoints.desktopMin, "px)"),
  'tablet+desktop': "(min-width: ".concat(devicesBreakpoints.tabletMin, "px)")
};
//# sourceMappingURL=parameters.js.map